/*
  ========================================================================
  TeeInBlue im PLATTFORMMODUS: Varianten- und Kaufknopf nachruesten
  ========================================================================

  Warum es diese Datei gibt, steht ausfuehrlich in snippets/tib-plattform.liquid.
  Kurz: bei ueber Printegy importierten Produkten rendert TeeInBlue nur die
  Personalisierungsfelder. Groesse, Farbe und Kaufknopf muessen vom Theme
  kommen - und das Theme blendet beides fuer TIB-Produkte ausdruecklich aus.

  Leitgedanke: NICHTS neu erfinden
  --------------------------------
  Die Auswahl wird in genau dem Markup nachgebaut, das die App bei den
  klassischen Produkten liefert (.tee-option / .tee-option__title /
  .tee-option-inner / .tee-radio / .tee-radio-label). Dadurch greifen alle
  bereits vorhandenen Bausteine von selbst - ohne eine einzige Sonderregel:

    tib-redesign-styles.css  Schrittnummer, Trennlinie, Kachelgestaltung
    tib-variant-tiles.js     Aufpreis "+ 12 EUR" und Bestseller-Eckband
    ext-main-product.js      klassische Farbkreise (sobald ein
                             .tee-swatch--color im Label steckt)
    tib-checkout.js          Kaufweg, Nebenweg, Vorhang, Wiederkauf
    paws-insights.js         configurator_step_view / _option / _add_to_cart

  Der Kaufknopf ist der zweite Kern der Sache. TeeInBlue hat dafuer eine
  eingebaute Schnittstelle, die nur niemand kannte:

    window.teeinblue.setupFormButtonEvents()

  Danach haengt sich die App an den KLICK eines ganz normalen
  button[type=submit][name=add] im Theme-Formular, prueft ihre Pflichtfelder
  selbst, legt die Personalisierung an (POST platform-customizations), fuellt
  properties[_customization_id] / [_customization_image] und laesst erst dann
  /cart/add.js durch. Eine eigene Pflichtpruefung waere also nicht nur
  ueberfluessig, sondern gefaehrlich - sie wuerde die der App verdoppeln.

  LEBENSWICHTIG: der Knopf muss GEKLICKT werden. Ein programmatisches
  form.requestSubmit() umgeht den Haken der App vollstaendig; nachgemessen
  landet der Artikel dann mit leerem _customization_id im Warenkorb, also
  ohne Motiv. Deshalb wird hier nirgends abgesendet.

  Zweitens haelt window.teeinblue.setVariantId() die Druckdatei der App an der
  gewaehlten Variante fest. Der Preis dagegen kommt vom Theme, sobald
  select[name="id"] ein change bekommt - dafuer braucht es hier keinen Code.
*/
(function () {
  'use strict';

  var SKRIPT = document.querySelector('script[data-paws-plattform]');
  if (!SKRIPT) return;

  var DATEN = null;
  try {
    DATEN = JSON.parse(SKRIPT.getAttribute('data-paws-plattform') || 'null');
  } catch (e) {
    DATEN = null;
  }
  if (!DATEN || !DATEN.varianten || !DATEN.varianten.length) return;

  var TXT_ATC = SKRIPT.getAttribute('data-paws-pf-atc') || 'In den Warenkorb';
  var TXT_AUS = SKRIPT.getAttribute('data-paws-pf-aus') || 'Ausverkauft';

  var TAKT_MS = 200;        // Drosselung des Beobachters
  var SUCH_TAKT_MS = 300;   // Anlaufversuche, solange die App noch laedt
  var SUCH_LAEUFE = 60;     // 18 Sekunden
  var LAUF_GRENZE = 12;     // Notaus: mehr Laeufe je Sekunde = Schleife
  var WACHSTUM_PX = 8;      // Notaus: Seite waechst bei jedem Lauf
  var WACHSTUM_GRENZE = 4;

  var WRAPPER_SEL = '#tee-artwork-form';
  var HAUPT_SEL = '.tee-customize-main-form';
  var FOOTER_SEL = '.tee-campaign-form-footer';

  /*
    Rueckfallfarben fuer den Fall, dass eine Farbvariante KEIN eigenes Bild
    mitbringt. Dann entsteht statt der Bildkachel ein .tee-swatch--color, und
    ext-main-product.js macht daraus von selbst den klassischen 34px-Kreis -
    genau wie bei den TeeInBlue-eigenen Produkten. Zusammengesetzte Namen wie
    "Blue/White" werden zum Zweifarbverlauf.
  */
  var FARBEN = {
    'schwarz': '#111111', 'black': '#111111',
    'weiss': '#ffffff', 'wei\u00df': '#ffffff', 'white': '#ffffff',
    'grau': '#9aa0a6', 'grey': '#9aa0a6', 'gray': '#9aa0a6',
    'anthrazit': '#3d4046', 'charcoal': '#3d4046',
    'blau': '#2c5aa0', 'blue': '#2c5aa0', 'navy': '#1b2a4a', 'royal': '#2c5aa0',
    'hellblau': '#8ec5e6', 'lightblue': '#8ec5e6', 'sky': '#8ec5e6',
    'rot': '#c0392b', 'red': '#c0392b', 'bordeaux': '#6d2231',
    'gr\u00fcn': '#3a7d44', 'gruen': '#3a7d44', 'green': '#3a7d44',
    'oliv': '#6b6b3a', 'olive': '#6b6b3a', 'mint': '#a8e0c8',
    'gelb': '#f2c94c', 'yellow': '#f2c94c',
    'rosa': '#f0a6bd', 'rose': '#f0a6bd', 'pink': '#e75480',
    'lila': '#7b5aa6', 'violett': '#7b5aa6', 'purple': '#7b5aa6',
    'orange': '#e8833a', 'apricot': '#f3b98a',
    'braun': '#7b5334', 'brown': '#7b5334',
    'beige': '#e3d5c0', 'creme': '#f3ead9', 'cream': '#f3ead9',
    'natur': '#e3d5c0', 'natural': '#e3d5c0', 'sand': '#ded3bd',
    'gold': '#d4af37', 'silber': '#c0c0c0', 'silver': '#c0c0c0',
    't\u00fcrkis': '#3ec1c1', 'tuerkis': '#3ec1c1', 'turquoise': '#3ec1c1',
    'petrol': '#2b6777', 'standard': '#d9dde3'
  };

  var GROESSE_WORTE = ['gr\u00f6\u00dfe', 'groesse', 'grosse', 'size', 'ma\u00df', 'mass'];
  var FARBE_WORTE = ['farbe', 'color', 'colour', 'farben'];

  /* -------------------------------------------------------------------- */
  /* Zustand                                                               */
  /* -------------------------------------------------------------------- */

  var bloecke = [];          // je Optionsposition ein Block (oder null)
  var aktionen = null;       // #teeFormActions
  var menge = null;          // input[name="quantity"]
  var knopf = null;
  var hakenGesetzt = false;  // setupFormButtonEvents() nur EINMAL je Knopf
  var startVariantGesetzt = false;

  var beobachter = null;
  var geplant = null;
  var laeuftGerade = false;
  var abgeschaltet = false;
  var laufFenster = 0, laufZaehler = 0;
  var letzteHoehe = 0, wachstumZaehler = 0;

  /* -------------------------------------------------------------------- */
  /* Kleine Helfer                                                         */
  /* -------------------------------------------------------------------- */

  function normal(s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  }

  function enthaelt(text, liste) {
    var n = normal(text);
    for (var i = 0; i < liste.length; i++) {
      if (n.indexOf(liste[i]) !== -1) return true;
    }
    return false;
  }

  function kaufFormular() {
    return document.querySelector('form.product-form');
  }

  /*
    Achtung: bei einem <form> liefert form.id NICHT das id-Attribut, sondern
    das darin enthaltene Element mit name="id" (benannter Zugriff). Deshalb
    hier immer ueber querySelector gehen, nie ueber form.id.
  */
  function auswahlFeld() {
    var f = kaufFormular();
    return f ? f.querySelector('select[name="id"]') : null;
  }

  function varianteZuId(id) {
    var s = String(id);
    for (var i = 0; i < DATEN.varianten.length; i++) {
      if (String(DATEN.varianten[i].id) === s) return DATEN.varianten[i];
    }
    return null;
  }

  function aktuelleVariante() {
    var feld = auswahlFeld();
    var v = feld && feld.value ? varianteZuId(feld.value) : null;
    if (v) return v;
    v = varianteZuId(DATEN.aktiv);
    return v || DATEN.varianten[0];
  }

  /* Alle vorkommenden Werte einer Optionsposition, in Variantenreihenfolge. */
  function werteFuer(pos) {
    var raus = [], gesehen = {};
    for (var i = 0; i < DATEN.varianten.length; i++) {
      var w = DATEN.varianten[i].w[pos];
      if (w == null || w === '') continue;
      if (Object.prototype.hasOwnProperty.call(gesehen, w)) continue;
      gesehen[w] = true;
      raus.push(w);
    }
    return raus;
  }

  /* Erstes Variantenbild zu einem Optionswert - Grundlage der Bildkacheln. */
  function bildFuer(pos, wert) {
    for (var i = 0; i < DATEN.varianten.length; i++) {
      var v = DATEN.varianten[i];
      if (v.w[pos] === wert && v.b) return v.b;
    }
    return '';
  }

  function farbeZu(wert) {
    var teile = String(wert).split('/');
    var farben = [];
    for (var i = 0; i < teile.length; i++) {
      var schluessel = normal(teile[i]).replace(/[^a-z\u00e4\u00f6\u00fc\u00df]/g, '');
      if (Object.prototype.hasOwnProperty.call(FARBEN, schluessel)) {
        farben.push(FARBEN[schluessel]);
      }
    }
    if (!farben.length) return '';
    if (farben.length === 1) return farben[0];
    return 'linear-gradient(135deg, ' + farben[0] + ' 0 50%, ' + farben[1] + ' 50% 100%)';
  }

  /*
    Die passende Variante zu einer Wunschkombination. Zuerst der exakte
    Treffer; gibt es den nicht (etwa weil eine Farbe nur in bestimmten
    Groessen existiert), gewinnt die Variante, die den GERADE ANGEKLICKTEN
    Wert fuehrt und von den uebrigen so viele wie moeglich behaelt. Lieferbare
    Varianten haben dabei immer Vorrang.
  */
  function passendeVariante(soll, pos) {
    var beste = null, bestePunkte = -1;
    for (var i = 0; i < DATEN.varianten.length; i++) {
      var v = DATEN.varianten[i];
      if (v.w[pos] !== soll[pos]) continue;
      var punkte = 0;
      for (var j = 0; j < soll.length; j++) {
        if (v.w[j] === soll[j]) punkte++;
      }
      if (v.v) punkte += 100;
      if (punkte > bestePunkte) { bestePunkte = punkte; beste = v; }
    }
    return beste;
  }

  /* Gibt es zu diesem Wert - bei sonst unveraenderter Auswahl - Ware? */
  function lieferbar(pos, wert, jetzt) {
    for (var i = 0; i < DATEN.varianten.length; i++) {
      var v = DATEN.varianten[i];
      if (!v.v || v.w[pos] !== wert) continue;
      var passt = true;
      for (var j = 0; j < jetzt.w.length; j++) {
        if (j !== pos && v.w[j] !== jetzt.w[j]) { passt = false; break; }
      }
      if (passt) return true;
    }
    return false;
  }

  /* -------------------------------------------------------------------- */
  /* Aufbau der Auswahlbloecke                                             */
  /* -------------------------------------------------------------------- */

  function radioBauen(pos, wert, istFarbe, mitBild, nr) {
    var id = 'paws-pf-' + pos + '-' + nr;

    var huelle = document.createElement('div');
    huelle.className = 'tee-radio';
    huelle.setAttribute('data-paws-pf-wert', wert);

    var eingabe = document.createElement('input');
    eingabe.type = 'radio';
    eingabe.id = id;
    eingabe.name = 'paws-pf-' + pos;
    eingabe.value = wert;
    eingabe.setAttribute('role', 'radio');
    huelle.appendChild(eingabe);

    var label = document.createElement('label');
    label.className = 'tee-radio-label';
    label.setAttribute('for', id);
    label.title = wert;

    if (istFarbe) {
      if (mitBild) {
        /*
          Bildkachel. Die Klasse .paws-tib-tile__bild gehoert UNS und traegt
          ihre Masse selbst - eine Klasse an einem Element der App waere
          geborgt (siehe assets/tib-variant-tiles.css).
        */
        var bild = document.createElement('img');
        bild.className = 'paws-tib-tile__bild';
        bild.src = bildFuer(pos, wert);
        bild.alt = '';
        bild.loading = 'lazy';
        label.appendChild(bild);
        huelle.classList.add('paws-tib-tile');
      } else {
        // Rueckfall: klassischer Farbkreis wie bei den TIB-eigenen Produkten.
        var farbe = farbeZu(wert);
        if (farbe) {
          var tupfen = document.createElement('span');
          tupfen.className = 'tee-swatch--color';
          tupfen.style.background = farbe;
          label.appendChild(tupfen);
        }
      }
    }

    var text = document.createElement('span');
    text.textContent = wert;
    label.appendChild(text);

    huelle.appendChild(label);
    return huelle;
  }

  function blockBauen(pos, name, istFarbe) {
    var werte = werteFuer(pos);
    if (werte.length < 2) return null;   // wie hide_single_value_option bei TIB

    /*
      Bildkachel oder Farbkreis wird fuer die GANZE Gruppe entschieden, nicht
      je Wert. Sonst stuenden gemischte Formen nebeneinander - und schlimmer:
      normalizeNonFrameColorSwatches() in ext-main-product.js zwaengt, sobald
      auch nur EIN .tee-swatch--color im Block steckt, jede Kachel der Gruppe
      per Inline-Stil auf 34x34 Pixel. Die Bilder waeren dann Kreise.
    */
    var mitBild = istFarbe;
    for (var b = 0; b < werte.length && mitBild; b++) {
      if (!bildFuer(pos, werte[b])) mitBild = false;
    }

    var block = document.createElement('div');
    block.className = 'tee-block tee-option paws-tib-pf ' +
      (istFarbe ? 'tee-option--color' : 'tee-option--size') +
      (mitBild ? ' paws-tib-tiles' : '');
    block.setAttribute('data-paws-pf-pos', String(pos));

    var titel = document.createElement('label');
    titel.className = 'tee-option__title';
    titel.id = 'paws-pf-titel-' + pos;
    titel.textContent = name;
    block.appendChild(titel);

    var reihe = document.createElement('div');
    reihe.className = 'tee-row tee-option-inner';
    reihe.setAttribute('role', 'radiogroup');
    reihe.setAttribute('aria-labelledby', titel.id);
    block.appendChild(reihe);

    for (var i = 0; i < werte.length; i++) {
      reihe.appendChild(radioBauen(pos, werte[i], istFarbe, mitBild, i));
    }

    block.addEventListener('change', function (e) {
      var ziel = e.target;
      if (!ziel || ziel.type !== 'radio') return;
      auswahlAnwenden(pos, ziel.value);
    });

    return block;
  }

  function bloeckeBauen() {
    if (bloecke.length) return;
    var namen = DATEN.namen || [];
    var anzahl = DATEN.varianten[0].w.length;
    for (var pos = 0; pos < anzahl; pos++) {
      var name = namen[pos] || '';
      var istFarbe = enthaelt(name, FARBE_WORTE);
      bloecke.push({
        pos: pos,
        istFarbe: istFarbe,
        istGroesse: enthaelt(name, GROESSE_WORTE),
        el: blockBauen(pos, name || (istFarbe ? 'Farbe' : 'Auswahl'), istFarbe)
      });
    }
  }

  /* -------------------------------------------------------------------- */
  /* Einhaengen - an denselben Stellen wie bei den klassischen Produkten    */
  /* -------------------------------------------------------------------- */

  /*
    Nachgemessen: Vue baut ausschliesslich #teeFormInputs innerhalb von
    .tee-customize-main-form neu auf. Fremde Knoten davor, danach und im
    Fussbereich ueberstehen sowohl einen Variantenwechsel als auch jede
    Feldaenderung. Trotzdem wird die Position bei jedem Lauf geprueft und nur
    dann geschrieben, wenn sie nicht stimmt - dieselbe Vorsicht wie ueberall
    sonst im TIB-Umfeld.

    Reihenfolge: ALLE Auswahlbloecke stehen geschlossen vor den
    Personalisierungsfeldern, in der Reihenfolge der Produktoptionen. Anders
    als bei den Produkten der App, wo die Farbe hinter den Feldern steht:
    dort ist sie eine Eigenschaft der bereits gewaehlten Ausfuehrung, hier
    bestimmt sie zusammen mit der Groesse ueberhaupt erst den Artikel - und
    damit Preis und Lieferbarkeit, die ueber allem stehen sollen.
  */
  function bloeckeEinhaengen(wurzel, haupt) {
    var alle = [], i;
    for (i = 0; i < bloecke.length; i++) {
      if (bloecke[i].el) alle.push(bloecke[i].el);
    }
    if (!alle.length) return;

    /*
      Erst die Soll-Reihenfolge nachlaufen und nur bei Abweichung schreiben.
      Ein blosses "steht mein Block direkt vor dem Hauptteil?" reicht nicht:
      bei ZWEI Bloecken davor ist der erste nie der direkte Vorgaenger - die
      Pruefung schluege immer fehl und jeder Lauf wuerde neu einhaengen.
    */
    var stimmt = true;
    var lauf = haupt.previousElementSibling;
    for (i = alle.length - 1; i >= 0; i--) {
      if (lauf !== alle[i]) { stimmt = false; break; }
      lauf = lauf.previousElementSibling;
    }
    if (!stimmt) {
      for (i = 0; i < alle.length; i++) wurzel.insertBefore(alle[i], haupt);
    }
  }

  /*
    Die Mengenauswahl ist Punkt fuer Punkt die der App nachgebaut
    (.tee-quantity > .tee-quantity-group > minus/input/plus). Dadurch greift
    deren eigenes Stylesheet - Breite 150px, Hoehe 52px, flex 0 0 150px -
    ohne dass hier ein einziges Mass gesetzt werden muesste. Nachgewiesen:
    TeeInBlue liest beim Kauf input[name="quantity"] aus dem Kaufformular
    aus, eine 3 im Feld kommt als "quantity": 3 in /cart/add.js an.
  */
  function mengeBauen() {
    var huelle = document.createElement('div');
    huelle.className = 'tee-quantity paws-tib-pf-menge';

    var titel = document.createElement('div');
    titel.className = 'tee-field__title sr-only';
    titel.textContent = 'Anzahl';
    huelle.appendChild(titel);

    var gruppe = document.createElement('div');
    gruppe.className = 'tee-quantity-group';

    var minus = document.createElement('span');
    minus.className = 'tee-quantity-handle tee-quantity-minus';
    minus.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.03 1.03 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029s-.463 1.029-1.029 1.029"></path></svg>';

    menge = document.createElement('input');
    menge.className = 'tee-quantity-input';
    menge.type = 'number';
    menge.name = 'quantity';
    menge.min = '1';
    menge.value = '1';
    menge.setAttribute('pattern', '[0-9]*');
    menge.setAttribute('aria-label', 'Anzahl');

    var plus = document.createElement('span');
    plus.className = 'tee-quantity-handle tee-quantity-plus';
    plus.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071"></path></svg>';

    function setzen(n) {
      var z = Math.max(1, Math.floor(n) || 1);
      if (String(z) !== menge.value) menge.value = String(z);
    }
    minus.addEventListener('click', function () { setzen(parseInt(menge.value, 10) - 1); });
    plus.addEventListener('click', function () { setzen(parseInt(menge.value, 10) + 1); });
    menge.addEventListener('change', function () { setzen(parseInt(menge.value, 10)); });

    gruppe.appendChild(minus);
    gruppe.appendChild(menge);
    gruppe.appendChild(plus);
    huelle.appendChild(gruppe);
    return huelle;
  }

  function aktionenEinhaengen(wurzel) {
    if (!aktionen) {
      aktionen = document.createElement('div');
      aktionen.id = 'teeFormActions';
      aktionen.className = 'tee-form-actions tee-form-actions--no-sticky tee-block paws-tib-pf-aktionen';

      /*
        Dieselbe Zeile wie bei den Produkten der App: eine Huelle
        .tee-form-action.tee-form-atc-wrapper mit display:flex, darin die
        Menge (fest 150px) und der Knopf (flex 1 1 auto). Genau daher
        stammt die klassische Knopfbreite - sie ist kein gesetztes Mass,
        sondern der Rest der Zeile.
      */
      var zeile = document.createElement('div');
      zeile.className = 'tee-form-action tee-form-atc-wrapper';

      knopf = document.createElement('button');
      knopf.type = 'submit';
      knopf.name = 'add';
      knopf.id = 'AddToCart-paws-tib-plattform';
      knopf.className = 'tee-btn tee-btn--atc paws-tib-pf-atc';
      knopf.style.setProperty('--paws-pf-aus', '"' + String(TXT_AUS).replace(/"/g, '') + '"');

      var text = document.createElement('span');
      text.textContent = TXT_ATC;
      knopf.appendChild(text);

      zeile.appendChild(mengeBauen());
      zeile.appendChild(knopf);
      aktionen.appendChild(zeile);
    }

    /*
      Der leere .tee-block im Fussbereich ist der von der App selbst
      vorgesehene Platz; er bleibt bei jedem Neuaufbau bestehen. Fehlt er,
      landet der Kaufknopf am Ende des Formulars - beides liegt innerhalb von
      form.product-form, und nur darauf kommt es an.
    */
    var fuss = wurzel.querySelector(FOOTER_SEL);
    var ziel = (fuss && fuss.querySelector('.tee-block')) || fuss || wurzel;
    /*
      Nur die Elternschaft pruefen, NICHT die letzte Position: tib-checkout.js
      haengt den Nebenweg "erst in den Warenkorb legen" direkt HINTER
      #teeFormActions. Wer hier auf lastElementChild bestuende, schoebe den
      Kaufknopf bei jedem Lauf wieder ans Ende - und beide Skripte schoeben
      sich gegenseitig im Kreis.
    */
    if (aktionen.parentNode !== ziel) ziel.appendChild(aktionen);
  }

  /*
    Der Haken der App. Erst ab hier prueft TeeInBlue beim Klick seine
    Pflichtfelder, legt die Personalisierung an und laesst /cart/add.js
    durch. Ausdruecklich nur EINMAL je Knopf: ein zweiter Aufruf koennte
    einen zweiten Zuhoerer anhaengen - und damit den Artikel doppelt in den
    Warenkorb legen.
  */
  function hakenSetzen() {
    if (hakenGesetzt || !knopf || !document.contains(knopf)) return;
    if (!window.teeinblue || typeof window.teeinblue.setupFormButtonEvents !== 'function') return;
    try {
      window.teeinblue.setupFormButtonEvents();
      hakenGesetzt = true;
    } catch (e) {
      // Beim naechsten Lauf noch einmal versuchen.
    }
    if (hakenGesetzt && !startVariantGesetzt) {
      startVariantGesetzt = true;
      varianteMelden(aktuelleVariante().id);
    }
  }

  /* -------------------------------------------------------------------- */
  /* Produktgalerie: bewusst nichts                                         */
  /* -------------------------------------------------------------------- */

  /*
    TeeInBlue haengt seine Vorschau (.tee-gallery-content) als ERSTES Kind in
    die Medienspalte und blendet mit der eigenen Regel ".tee-gallery-content
    ~ *" Buehne, Punkte und Vorschaubilder des Themes aus. Das ist so
    gewollt: die App stellt ihre eigene Galerie - ein Slide je Mockup der
    Kampagne, jedes davon live bearbeitbar, dazu eine Vorschaubildleiste.

    Welches Mockup zu welcher Variante gehoert, steht in der Kampagne
    (platform_variant_ids). Beim Farbwechsel genuegt deshalb varianteMelden()
    weiter unten - die App sucht sich das passende Mockup selbst.

    Hier stand frueher eine nachgebaute Galerie, die die Produktfotos
    deckungsgleich ueber die Vorschau der App legte. Noetig war sie nur,
    solange eine Kampagne bloss EIN Mockup hatte und dadurch immer dieselbe
    Farbe zeigte. Wer diesen Zustand wiedersieht, legt die fehlenden Mockups
    in der Kampagne an - nicht hier im Theme.
  */

  /* -------------------------------------------------------------------- */
  /* Auswahl anwenden                                                      */
  /* -------------------------------------------------------------------- */

  /*
    setVariantId haelt die Druckdatei der App an der gewaehlten Variante fest
    (nachweisbar an platform_linked_id in getCurrentCustomization()). Es
    ruehrt select[name="id"] NICHT an - beides muss getrennt gesetzt werden.
  */
  function varianteMelden(id) {
    try {
      if (window.teeinblue && typeof window.teeinblue.setVariantId === 'function') {
        window.teeinblue.setVariantId(Number(id));
      }
    } catch (e) {}
  }

  function auswahlAnwenden(pos, wert) {
    var jetzt = aktuelleVariante();
    var soll = jetzt.w.slice();
    soll[pos] = wert;

    var ziel = passendeVariante(soll, pos);
    if (!ziel) return;

    var feld = auswahlFeld();
    if (feld && String(feld.value) !== String(ziel.id)) {
      /*
        Nur zuweisen, wenn es die Option wirklich gibt: bei einer unbekannten
        ID setzt der Browser value auf "" und selectedIndex auf -1 - danach
        finden auch tib-variant-tiles.js und tib-frames.js keine Bezugs-
        variante mehr und alle Aufpreise verschwinden.
      */
      var option = null;
      for (var i = 0; i < feld.options.length; i++) {
        if (String(feld.options[i].value) === String(ziel.id)) { option = feld.options[i]; break; }
      }
      if (option) {
        feld.value = String(ziel.id);
        // Der Preis des Themes haengt an diesen beiden Ereignissen.
        feld.dispatchEvent(new Event('input', { bubbles: true }));
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /*
      Damit wechselt auch das Mockup der App: TeeInBlue kennt aus der Kampagne
      die Zuordnung Variante -> Mockup und blendet das passende Bild ein.
    */
    varianteMelden(ziel.id);
    zustandSetzen();
  }

  /* -------------------------------------------------------------------- */
  /* Zustand spiegeln (vergleichen, dann erst schreiben)                   */
  /* -------------------------------------------------------------------- */

  function zustandSetzen() {
    var jetzt = aktuelleVariante();
    var ausverkauft = !jetzt.v;

    for (var i = 0; i < bloecke.length; i++) {
      var b = bloecke[i];
      if (!b.el) continue;
      var radios = b.el.querySelectorAll('.tee-radio');
      for (var k = 0; k < radios.length; k++) {
        var radio = radios[k];
        var wert = radio.getAttribute('data-paws-pf-wert');
        var eingabe = radio.querySelector('input[type="radio"]');
        var aktiv = wert === jetzt.w[b.pos];

        if (eingabe && eingabe.checked !== aktiv) eingabe.checked = aktiv;
        if (radio.classList.contains('active') !== aktiv) radio.classList.toggle('active', aktiv);
        var ariaSoll = aktiv ? 'true' : 'false';
        if (radio.getAttribute('aria-checked') !== ariaSoll) radio.setAttribute('aria-checked', ariaSoll);

        var leer = !aktiv && !lieferbar(b.pos, wert, jetzt);
        if (radio.classList.contains('paws-tib-pf-leer') !== leer) {
          radio.classList.toggle('paws-tib-pf-leer', leer);
        }
      }
    }

    if (knopf) {
      if (knopf.disabled !== ausverkauft) knopf.disabled = ausverkauft;
      if (knopf.classList.contains('paws-tib-pf-aus') !== ausverkauft) {
        knopf.classList.toggle('paws-tib-pf-aus', ausverkauft);
      }
    }
    /*
      Schalterklassen gehoeren an <html>, nie an einen Knoten der App: deren
      class-Attribut wird staendig neu geschrieben. Hieran haengt das
      Ausblenden des Nebenwegs "erst in den Warenkorb legen".
    */
    if (document.documentElement.classList.contains('paws-tib-pf-aus') !== ausverkauft) {
      document.documentElement.classList.toggle('paws-tib-pf-aus', ausverkauft);
    }
  }

  /* -------------------------------------------------------------------- */
  /* Lauf, Drosselung und Notaus                                           */
  /* -------------------------------------------------------------------- */

  function notaus(grund) {
    abgeschaltet = true;
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    if (window.console && console.warn) console.warn('[TIB-Plattform] abgeschaltet:', grund);
  }

  function anwenden() {
    if (abgeschaltet || laeuftGerade) return false;

    var jetzt = Date.now();
    if (jetzt - laufFenster > 1000) { laufFenster = jetzt; laufZaehler = 0; }
    if (++laufZaehler > LAUF_GRENZE) { notaus('zu viele Laeufe je Sekunde'); return false; }

    var wurzel = document.querySelector(WRAPPER_SEL);
    if (!wurzel) return false;
    var haupt = wurzel.querySelector(HAUPT_SEL);
    if (!haupt) return false;

    laeuftGerade = true;
    try {
      bloeckeBauen();
      bloeckeEinhaengen(wurzel, haupt);
      aktionenEinhaengen(wurzel);
      zustandSetzen();
      hakenSetzen();
    } catch (e) {
      if (window.console && console.warn) console.warn('[TIB-Plattform]', e);
    } finally {
      /*
        Die eigenen Schreibvorgaenge nicht als fremde Aenderung zurueck-
        bekommen - sonst loest jeder Lauf den naechsten aus.
      */
      if (beobachter) beobachter.takeRecords();
      laeuftGerade = false;
    }

    /*
      Zweiter Notaus: eine gedrosselte Schleife erzeugt nur rund fuenf Laeufe
      je Sekunde und rutscht damit unter der Grenze oben hindurch. Waechst die
      Seite aber bei jedem Lauf weiter, ist es trotzdem eine.
    */
    var hoehe = document.documentElement.scrollHeight;
    if (letzteHoehe && hoehe - letzteHoehe > WACHSTUM_PX) {
      if (++wachstumZaehler >= WACHSTUM_GRENZE) { notaus('Seite waechst bei jedem Lauf'); }
    } else {
      wachstumZaehler = 0;
    }
    letzteHoehe = hoehe;

    return true;
  }

  function planen() {
    if (geplant || abgeschaltet) return;
    geplant = setTimeout(function () {
      geplant = null;
      anwenden();
    }, TAKT_MS);
  }

  function beobachten() {
    if (beobachter || typeof MutationObserver !== 'function') return;
    var wurzel = document.getElementById('teeinblue-form');
    if (!wurzel) return;
    beobachter = new MutationObserver(function () {
      if (laeuftGerade) return;
      planen();
    });
    beobachter.observe(wurzel, { childList: true, subtree: true });
  }

  function starten() {
    var laeufe = 0;
    var suche = setInterval(function () {
      laeufe++;
      var da = anwenden();
      if (da) beobachten();
      if ((da && hakenGesetzt) || laeufe >= SUCH_LAEUFE || abgeschaltet) clearInterval(suche);
    }, SUCH_TAKT_MS);
    anwenden();

    /*
      Andere Stellen im Theme setzen select[name="id"] ebenfalls (etwa der
      Abgleich mit ?variant= aus der Adresse). Dann muessen die Kacheln
      nachziehen - zustandSetzen() schreibt nur, was nicht stimmt, ein
      Aufschaukeln mit dem eigenen dispatch ist damit ausgeschlossen.
    */
    document.addEventListener('change', function (e) {
      var ziel = e.target;
      if (!ziel || ziel.name !== 'id' || ziel.tagName !== 'SELECT') return;
      if (abgeschaltet) return;
      zustandSetzen();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  /*
    Zurueck aus der Kasse: der Browser stellt die Seite aus dem Zwischen-
    speicher wieder her, ohne DOMContentLoaded erneut auszuloesen.
  */
  window.addEventListener('pageshow', function () {
    if (abgeschaltet) return;
    anwenden();
  });
})();
